<div class="payment-order-customer">
  <div class="payment-order-customer-label">
    <app-validated-form-row
      [isRemoveHidden]="true"
      [isEditHidden]="isEditMode()"
      (edit)="onEdit()"
      data-cy="customer-to-be-refunded"
    >
      <ng-template #labelTemp>
        <ng-container>
          <h5>{{ selectionTitle() | translate }}</h5>
        </ng-container>
      </ng-template>
    </app-validated-form-row>
  </div>
  @if(isEditMode()) {
  <div class="payment-customer-value">
    <app-customer-dropdown-list
      [data]="customerData"
      [isLoading]="isLoading"
      [selectedId]="selectedCustomerId"
      [allowCustomerCreation]="false"
      [allowCustomerEdit]="false"
      [styleClass]="'ng-select-sm'"
      (searchTrigger)="onSearchTrigger($event)"
      (selectedChange)="onCustomerChange($event)"
      (clearTrigger)="onClearTrigger()"
      data-cy="refund-customer-dropdown"
    ></app-customer-dropdown-list>
  </div>
  }@else {
  <app-validated-form-row [isRemoveHidden]="true" [isEditHidden]="true">
    <ng-template #labelTemp>
      @if(isAnonymous()) {
      <span class="ms-1"> {{ 'shared.customer.anonymousCustomer' | translate }} </span>}@else {
      <ng-container *ngTemplateOutlet="isMoralCustomer() ? moralCustomerForm : physicalCustomerForm">
      </ng-container
      >}
    </ng-template>
  </app-validated-form-row>
  }
</div>

<ng-template #moralCustomerForm>
  <div class="label-item-bold">
    <span>
      {{ selectedCustomer()?.name }}
    </span>
  </div>
</ng-template>
<ng-template #physicalCustomerForm>
  <div class="label-item-bold">
    @if(isAnonymous()) {<span class="ms-1"> {{ 'shared.customer.anonymousCustomer' | translate }} </span
    >}@else {
    <span> {{ selectedCustomer()?.name }} </span>
    }
  </div>
</ng-template>
